export function getGoogleEditorUrl(
  idOrUrl: string,
  mimeType?: string // optional, when you have it from Drive API
): string {
  if (!idOrUrl) return ''

  // If caller already saved a full URL, just use it
  if (/^https?:\/\//i.test(idOrUrl)) return idOrUrl

  const id = encodeURIComponent(idOrUrl)

  // If you know the mimeType, route to the correct editor
  switch (mimeType) {
    case 'application/vnd.google-apps.document':
      return `https://docs.google.com/document/d/${id}/edit`
    case 'application/vnd.google-apps.spreadsheet':
      return `https://docs.google.com/spreadsheets/d/${id}/edit`
    case 'application/vnd.google-apps.presentation':
      return `https://docs.google.com/presentation/d/${id}/edit`
    default:
      // Safe universal opener for any Drive file
      return `https://drive.google.com/open?id=${id}`
  }
}
